import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countryFlagApi',
  standalone: false
})
export class CountryFlagApiPipe implements PipeTransform {
  private readonly FLAG_20X15_URL = `https://flagcdn.com/20x15/`;
  
  transform(countryCode: string): string {
    return `${this.FLAG_20X15_URL}${countryCode.toLowerCase()}.png`;
  }

}
